<template>
  <TrfSimpleModal
    :isAtivo="isAberto"
    :isFecharComBackground="false"
    :isFecharComX="false"
    :customStyleBody="isEtapaEmpresa ? 'padding-top: 0px;' : ''"
  >
    <template v-slot:modal-header>
      <div class="modal-card-head has-background-primary">
        <p class="modal-card-title has-text-white">
          AVA-Assistente Virtual Alterdata
          <template v-if="show.conclusao">
            <br/><span class="is-size-5">Configurando</span>
          </template>
          <template v-else-if="show.concluido">
            <br/><span class="is-size-5">Finalizando</span>
          </template>
          <template v-else-if="etapa.atual != etapa.introducao && etapas[etapa.atual].titulo">
            <br/><span class="is-size-5">{{etapas[etapa.atual].titulo}}</span>
          </template>
        </p>
      </div>
    </template>

    <div class="trf-wizard is-relative" :class="show.conclusao || show.concluido ? 'trf-wizard-concluindo' : ''" :data-etapa="etapa.atual">
      <div v-if="show.splash" class="trf-wizard-splash">
        <AVALoader type="overlay" style="width:100%; height:100%">
          <p class="my-4 has-text-centered is-size-4">
            Estamos carregando os dados para configuração, aguarde...
          </p>
        </AVALoader>
      </div>
      <div v-else-if="show.conclusao" class="trf-wizard-conclusao">
        <AVALoader type="overlay" style="width:100%; height:100%">
          <p class="my-4 has-text-centered is-size-4">
            Um momento. Estou preparando<br/>este recurso para você.
          </p>
        </AVALoader>
      </div>
      <div v-else-if="show.concluido" class="trf-wizard-conclusao">
        <AVALoader type="overlay" style="width:100%; height:100%">
          <p class="my-4 has-text-centered is-size-4">
            Tudo pronto!<br/>Você já pode utilizar o sistema!
          </p>
        </AVALoader>
      </div>
      <div v-else class="trf-wizard-conteudo">
        <div v-if="etapa.atual == etapa.introducao" class="trf-wizard-conteudo-etapa trf-wizard-etapa" data-etapa="inicial">
          <div class="content">
            <p>
              Olá, bem-vindo ao eTarefas.
            </p>
            <p>
              Eu sou a AVA (Assistente Virtual Alterdata) e estou aqui para configurar o seu sistema para uso! Antes de iniciar, vou precisar das informações abaixo para deixar tudo pronto!
            </p>
            <ul class="configs-necessarias">
              <li v-for="etapa in etapas" :key="etapa.titulo" class="has-text-weight-bold">{{etapa.titulo}}</li>
            </ul>
            <p>
              Vamos lá?
            </p>
          </div>
        </div>
        <div
          class="trf-wizard-conteudo-etapa trf-wizard-etapa"
          data-etapa="data"
          v-else-if="etapas[etapa.atual].nome == etapasEnum.DATA"
        >
          <div class="content">
            <TrfWizardModuloDataDeInicio
              :valorInicial="etapas[etapa.atual].valor.dataInicioTarefasWeb"
              @update:dataInicioTarefasWeb="data => etapas[etapa.atual].valor.dataInicioTarefasWeb = data"
              @update:isDataValida="isValida => etapas[etapa.atual].isValida = isValida"
            >
            </TrfWizardModuloDataDeInicio>
          </div>
        </div>
        <div
          class="trf-wizard-conteudo-etapa trf-wizard-etapa"
          data-etapa="departamentos"
          v-else-if="etapas[etapa.atual].nome == etapasEnum.DEPARTAMENTOS"
        >
          <div>
            <TrfWizardModuloDepartamentos
              :departamentos="etapas[etapa.atual].departamentos"
              :departamentosPadraoFaltantes="configuracaoPendente.departamentosPadraoFaltantes"
              :departamentosConfigurados="etapas[etapa.atual].valor.departamentosPadraoConfigurados"
              :departamentosNaoConfigurados="etapas[etapa.atual].departamentosNaoConfigurados"
              @update:departamentosConfigurados="dp => etapas[etapa.atual].valor.departamentosPadraoConfigurados = dp"
              @update:departamentosNaoConfigurados="dp => etapas[etapa.atual].departamentosNaoConfigurados = dp"
            >
            </TrfWizardModuloDepartamentos>
          </div>
        </div>
        <div
          class="trf-wizard-conteudo-etapa trf-wizard-etapa"
          data-etapa="empresas"
          v-else-if="etapas[etapa.atual].nome == etapasEnum.EMPRESAS"
        >
          <div style="padding-top: 8px">
            <TrfWizardModuloEmpresas
              :empresas="etapas[etapa.atual].todasEmpresas"
              :empresasSelecionadas="etapas[etapa.atual].valor.empresas"
              @update:empresasSelecionadas="empresas => {
                etapas[etapa.atual].isValida = !!empresas.length;
                etapas[etapa.atual].valor.empresas = empresas;
              }"
            ></TrfWizardModuloEmpresas>
          </div>
        </div>
      </div>
    </div>

    <template v-slot:slot-footer>
      <div>
        <div v-if="!show.splash">
          <button
            class="button"
            v-if="etapa.atual == etapa.introducao"
            @click="_voltarAoEcontador()"
          >
            Voltar ao eContador
          </button>
          <button
            v-else
            class="button"
            :disabled="!isRetornoValido || show.conclusao || show.concluido"
            @click="_executarAnterior()"
          >
            Anterior
          </button>

          <button
            v-if="!isEtapaFinal"
            class="button is-primary"
            :disabled="!isEtapaValida || show.concluido"
            @click="_executarProximo()"
          >
            Próximo
          </button>
          <button
            v-else
            class="button is-primary"
            :class="{ 'is-loading': show.conclusao }"
            :disabled="!isEtapaValida || show.conclusao || show.concluido"
            :title="concluirTitle"
            @click="_executarConclusao()"
          >
            Concluir
          </button>
        </div>
      </div>
    </template>
  </TrfSimpleModal>
</template>

<script>
import TrfSimpleModal from "../Modal/TrfSimpleModal.vue"
import TrfWizardModuloDataDeInicio from "./TrfWizardModuloDataDeInicio.vue"
import TrfWizardModuloDepartamentos from "./TrfWizardModuloDepartamentos.vue"
import AVALoader from "../GlobalLoader/AVALoader.vue"
import TrfWizardModuloEmpresas from "./TrfWizardModuloEmpresas.vue"

import {toastUtils} from "../../util/toast.utils"
import {redirectUtils} from "../../util/redirect.utils"
import {configuracaoPendenteService} from "../../service/configuracao-pendente-service"
import {etapasConfiguracaoEnum} from "../../enums/etapasConfiguracaoEnum"
import {empresasService} from "../../service/empresas-service"
import {departamentoService} from "../../service/departamento-service"

export default {
  name: "TrfWizardConfiguracaoPendente",
  components: {
    TrfSimpleModal,
    TrfWizardModuloDataDeInicio,
    TrfWizardModuloDepartamentos,
    TrfWizardModuloEmpresas,
    AVALoader
  },
  props: {
    isAberto: {
      type: Boolean,
      default: false,
      required: false
    },
    configuracaoPendente: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      show: {
        splash: true,
        conclusao: false,
        concluido: false
      },
      etapa: {
        atual: -1,
        introducao: -1
      },
      etapas: [],
      etapasEnum: etapasConfiguracaoEnum
    };
  },
  methods: {
    _executarProximo() {
      if(!this.isEtapaValida) {
        toastUtils.dangerToast("Dados inválidos, verifique os campos e tente novamente");
        return;
      }

      this.etapa.atual += 1;
    },
    _executarAnterior() {
      if(!this.isRetornoValido) {
        toastUtils.dangerToast("Não é permitido retornar neste etapa");
        return;
      }

      this.etapa.atual -= 1;
    },
    _splash(ativo) {
      this.show.splash = ativo;
    },
    _voltarAoEcontador() {
      redirectUtils.redirecionarParaEcontador();
    },
    async _executarConclusao() {
      try {
        this.show.conclusao = true;
        await configuracaoPendenteService.configurar(this.dadosRequisicao);
        this.show.conclusao = false;
        this._concluido();
      } catch (e) {
        console.warn(e);
        toastUtils.dangerToast("Houve um erro ao salvar suas configurações. Retornando ao eContador");
        setTimeout(() => {
          this._voltarAoEcontador();
        }, 3000);
      }
    },
    _concluido() {
      this.show.concluido = true;
      this._recarregar();
    },
    _recarregar() {
      setTimeout(() => {
          window.location.reload(true)
      }, 3000);
    },
    async _inicializarConfiguracoesPendentes() {
      const hasDataInicioTarefas = this.configuracaoPendente.dataInicioTarefasWeb != null;
      if(!hasDataInicioTarefas) {
        this.etapas.push({
          nome: this.etapasEnum.DATA,
          titulo: "Data de início de uso",
          isValida: false,
          podeVoltar: true,
          valor: {
            dataInicioTarefasWeb: null
          }
        });
      }

      if(this.configuracaoPendente.departamentosPadraoFaltantes.length != 0) {
        const departamentos = await departamentoService.listar();
        this.etapas.push({
          nome: this.etapasEnum.DEPARTAMENTOS,
          titulo: "Departamentos",
          isValida: true,
          podeVoltar: true,
          valor: {
            departamentosPadraoConfigurados: []
          },
          departamentos,
          departamentosNaoConfigurados: []
        });
      }

      if(!hasDataInicioTarefas) {
        const todasEmpresas = await empresasService.listarEmpresasObjetoCompleto();
        this.etapas.push({
          nome: this.etapasEnum.EMPRESAS,
          titulo: "Empresa",
          isValida: false,
          podeVoltar: true,
          valor: {
            empresas: []
          },
          todasEmpresas
        });
      }

      this._splash(false);
    }
  },
  computed: {
    isEtapaValida() {
      if(this.etapa.atual == this.etapa.introducao) {
        return true;
      }

      return this.etapas[this.etapa.atual].isValida;
    },
    isRetornoValido() {
      if(this.etapa.atual == this.etapa.introducao) {
        return false;
      }

      return this.etapas[this.etapa.atual].podeVoltar;
    },
    dadosRequisicao() {
      const etapasComDados = this.etapas.filter((etapa) => !!etapa.valor);
      let objetoDeDados = {};
      etapasComDados.forEach(etapa => {
        objetoDeDados = {...objetoDeDados, ...etapa.valor};
      })
      return objetoDeDados
    },
    isEtapaEmpresa() {
      if(this.etapa.atual == -1) {
        return false;
      }

      return this.etapas[this.etapa.atual].nome == this.etapasEnum.EMPRESAS
    },
    isEtapaFinal() {
      return this.etapa.atual == this.etapas.length - 1;
    },
    concluirTitle() {
      if(this.etapas[this.etapa.atual].nome == this.etapasEnum.EMPRESAS && !this.isEtapaValida) {
        return "Selecione pelo menos uma empresa para prosseguir.";
      }

      return "";
    }
  },
  mounted() {
    this._inicializarConfiguracoesPendentes();
  }
};

</script>

<style lang="scss" scoped>
.trf-wizard-concluindo {
  min-height: 310px
}

.trf-wizard-splash {
  min-height: 280px
}
</style>